var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollbar",class:_vm.classes},[_c('div',{ref:"simpleBar",staticClass:"simple-bar",style:({ 'max-height': _vm.maxHeight ? (_vm.maxHeight + "px") : 'none' })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }